import { IconProps } from "../../utils/global-types/global-types";

const ConcurrentLogoIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 26"
    fill="none"
    className={className ? className : "w-[30px] h-[26px]"}
    {...rest}
  >
    <path
      d="M14.886 17.189V25.779L29.763 17.189L22.325 12.889L14.886 17.189Z"
      fill="#061C32"
    />
    <path
      d="M0 17.189V25.779L14.885 17.189L7.439 12.889L0 17.189Z"
      fill="#061C32"
    />
    <path
      d="M14.886 8.59L29.763 17.189V8.59L14.886 0V8.59Z"
      fill="#DF2070"
    />
    <path d="M0 8.59L14.885 17.189V8.59L0 0V8.59Z" fill="#DF2070" />
  </svg>
);

export default ConcurrentLogoIcon;
